var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 18.75H20V3.75C20 3.55109 19.921 3.36032 19.7803 3.21967C19.6397 3.07902 19.4489 3 19.25 3H14C13.8011 3 13.6103 3.07902 13.4697 3.21967C13.329 3.36032 13.25 3.55109 13.25 3.75V7.5H8.75C8.55109 7.5 8.36032 7.57902 8.21967 7.71967C8.07902 7.86032 8 8.05109 8 8.25V12H4.25C4.05109 12 3.86032 12.079 3.71967 12.2197C3.57902 12.3603 3.5 12.5511 3.5 12.75V18.75H2.75C2.55109 18.75 2.36032 18.829 2.21967 18.9697C2.07902 19.1103 2 19.3011 2 19.5C2 19.6989 2.07902 19.8897 2.21967 20.0303C2.36032 20.171 2.55109 20.25 2.75 20.25H20.75C20.9489 20.25 21.1397 20.171 21.2803 20.0303C21.421 19.8897 21.5 19.6989 21.5 19.5C21.5 19.3011 21.421 19.1103 21.2803 18.9697C21.1397 18.829 20.9489 18.75 20.75 18.75ZM14.75 4.5H18.5V18.75H14.75V4.5ZM9.5 9H13.25V18.75H9.5V9ZM5 13.5H8V18.75H5V13.5Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkets);
export default __webpack_public_path__ + "static/media/Markets.f7436dd10b44da81bbbbd77e169ac753.svg";
export { ForwardRef as ReactComponent };